import React from 'react';
import DataValidator from 'js/components/Common/DataValidator/DataValidator';
import SingleInterestsCheckbox from 'js/components/Common/SingleInterestsCheckbox/SingleInterestsCheckbox';

import {TabType} from './ExploreContentSlider';
import classes from './ExploreContentTabs.module.pcss';

interface Props {
    tabs: Array<TabType>,
    activeTab: string,
    tabClickHandler: Function
}



const ExploreContentTabs = ({tabs, activeTab, tabClickHandler}:Props) => (
    <DataValidator data={tabs?.length > 0}>
        <div className={classes.ExploreContentTabs}>
            {tabs?.map((item) => {
                const {id, name} = item || null;
                return (
                    <div
                        onClick={() => tabClickHandler(id, name)}
                        className={`${classes.TabItem} ${parseInt(activeTab) === parseInt(id) ? classes.Active : ''}`}
                        key={id}>
                        <span>{name}</span>
                        <span>{name}</span>
                    </div>
                );
            })}
            {tabs?.map(item =>
                <div key={item?.id} className={`${classes.CheckBoxWrap} ${parseInt(activeTab) === parseInt(item?.id) ? classes.Active : ''}`}>
                    <SingleInterestsCheckbox
                        grId={item?.grId}
                        databaseId={item?.id}
                        name={item?.name}
                    />
                </div>
            )}
        </div>
    </DataValidator>
);

export default ExploreContentTabs;
